import { factoryService, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'

import { REACT_APP_API_PRINCIPAL_URL, REACT_APP_UNIQUE_PASS_ORIGIN } from '../configs/settings/environment'

/**
 * Gets the user info contained in the token.
 */
export const getAuthInfo = factoryService(() => getJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/auth/info`))

/**
 * Gets a valid public token.
 */
export const getPublicToken = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/auth/publico`, {
    isPublic: true
  })
})

/**
 * Gets authorization token to access the user's information from Civil Registry.
 */
export const getUniquePassToken = factoryService(({ code, state }) => {
  const body = {
    code,
    state
  }

  return postJsonRequest(
    `${REACT_APP_API_PRINCIPAL_URL}/v1/registro-civil/clave-unica/sso/token?aplicativo=${REACT_APP_UNIQUE_PASS_ORIGIN}`,
    {
      body
    }
  )
})

/**
 * Gets the user's information from Civil Registry.
 */
export const getUniquePassUserInfo = factoryService(({ token }) => {
  const body = {
    tokenClaveUnica: token
  }

  return postJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/registro-civil/clave-unica/sso/userinfo`, { body })
})

/**
 * Sign out the current session in the Civil Registry.
 */
export const logoutUniquePass = factoryService(({ refreshToken }) => {
  const body = {
    refreshToken
  }

  return postJsonRequest(
    `${REACT_APP_API_PRINCIPAL_URL}/v1/registro-civil/clave-unica/sso/logout?aplicativo=${REACT_APP_UNIQUE_PASS_ORIGIN}`,
    {
      body
    }
  )
})
